import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { useSwing, useActivitySwings } from '@queries';
import { userSettingsAtom, activityIdAtom } from '@store';

export const useComparisonSwingName = () => {
    const { comparisonSwingId, showComparison } = useAtomValue(userSettingsAtom);

    const { data: swing } = useSwing(comparisonSwingId || '');
    const activityId = useAtomValue(activityIdAtom);
    const { data: activitySwings = [] } = useActivitySwings(activityId);

    const comparisonName = useMemo((): string => {
        if (!swing) return '';
        if (swing.name) {
            return swing.name;
        }
        const activitySwingIndex = activitySwings.findIndex(({ uuid }) => uuid === comparisonSwingId);
        const activitySwingNumber = activitySwingIndex !== -1 ? activitySwings[activitySwingIndex].number : 0;

        if (activitySwingNumber) {
            return `Swing ${activitySwingNumber}`;
        }

        return 'Untitled swing';
    }, [activitySwings, comparisonSwingId, swing]);

    return {
        comparisonName,
        comparisonSwing: swing,
        showComparison,
    };
};
